import { IApplicationState } from '../../types/redux';

export function selectFiltersUrl(state: IApplicationState): string | null {
  return state.filtersUrl;
}
